export default __webpack_public_path__ + "static/media/group.abb751e1.png";